import { Alert, Stack, Typography } from "@mui/material";
import FormikDateMetaFields from "@poseidon/ui/components/form/FormikDateMetaFields";
import { AddressManagementSection } from "../components/edit/AddressManagementSection";
import { BasicDetailFields } from "../components/edit/BasicDetailFields";
import { ConsentFields } from "../components/edit/ConsentFields";
import { EmploymentFields } from "../components/edit/EmploymentFields";
import { IncomeFields } from "../components/edit/IncomeFields";
import { TaxFields } from "../components/edit/TaxFields";
import { AgreementSailorAddressManagement } from "../components/edit/AgreementSailorAddressManagement";
import { AgreementSailorFiles } from "../components/edit/AgreementSailorFiles";
import { SailorLocksSummary } from "../components/edit/SailorLocksSummary";
import {
  VulnerabilityFields,
  VulnerabilityNotes,
} from "../components/edit/VulnerabilityFields";
import { PanelGroup } from "@poseidon/ui/components/Panel";
import { useSailorRiskProfileContext } from "../SailorContext";
import { SailorCheckList } from "../../CheckList/components/SailorCheckList";
import { useParams } from "react-router-dom";

export function SailorForm({ context, isAgreementSailor }) {
  const { applicationId } = useParams();
  const sailor = context();
  const riskProfile = useSailorRiskProfileContext();
  return (
    <Stack
      spacing={5}
      sx={{
        mx: 5,
        mb: 5,
      }}
    >
      <Typography variant="h5">
        {isAgreementSailor && `Agreement`} Sailor Record
      </Typography>
      {isAgreementSailor && (
        <Alert severity="warning">
          This is a snapshot of the Sailor record at the time of Agreement
          creation.
        </Alert>
      )}
      <BasicDetailFields sailor={sailor} disabled={isAgreementSailor} />
      <PanelGroup>
        <VulnerabilityFields
          sailor={sailor}
          riskProfile={riskProfile}
          disabled={isAgreementSailor}
        />
        <VulnerabilityNotes sailor={sailor} />
      </PanelGroup>
      <TaxFields sailor={sailor} readonly={isAgreementSailor} />
      <EmploymentFields sailor={sailor} readonly={isAgreementSailor} />
      <IncomeFields sailor={sailor} readonly={isAgreementSailor} />
      <ConsentFields sailor={sailor} readonly={isAgreementSailor} />

      {isAgreementSailor ? (
        <>
          <AgreementSailorAddressManagement
            sailorAddresses={sailor.sailorAddresses}
          />
          <AgreementSailorFiles files={sailor.files} />
        </>
      ) : (
        <AddressManagementSection sailor={sailor} />
      )}
      {!isAgreementSailor && <SailorLocksSummary sailor={sailor} />}
      {!isAgreementSailor && <SailorCheckList sailor={sailor} />}
      <FormikDateMetaFields values={sailor} applicationId={applicationId} />
    </Stack>
  );
}
